import React from "react";
import { connect } from "react-redux";
import { compose, lifecycle, withHandlers } from "recompose";

import Checkbox from "react-md/lib/SelectionControls/Checkbox";
import SelectField from "react-md/lib/SelectFields";
import TextField from "react-md/lib/TextFields";
import FontIcon from "react-md/lib/FontIcons";
import Translate from "../Atollon/Translation";
import Buttons from "../components/Buttons";
import { Button, Card } from "react-md";
import ListItem from "react-md/lib/Lists/ListItem";
import Avatar from "react-md/lib/Avatars";
import List from "react-md/lib/Lists/List";
import CardText from "react-md/lib/Cards/CardText";

import Subheader from "react-md/lib/Subheaders";


// TODO: why there are 2 <Card>s ?
// import Button from "react-md/lib/Buttons/Button";
// import Card from "react-md/lib/Cards/Card";

import * as storage from "../utils/storage"

import {debug_processUser,debug_isEnabled} from "../Atollon/debug";
import {getUser} from "../actions/userActions";
import {map} from "lodash";

const DeveloperHelper = ({ history, user, data }) => {

    if(debug_isEnabled())
    {

        const userAvatar = <Avatar icon={<FontIcon>person</FontIcon>} suffix="black" />;

        return (
            <div className="flex-col">


                <List className="md-paper--1">
                    <Subheader primaryText={"Titulek subheader"} />
                </List>


                <h1 className={"title"}>BOX GREY BACKGROUND</h1>

                {/*
                            <List className="md-paper--1">
                                {/ * data && <Subheader primaryText={data} /> * / }
                                    <ListItem
                                        leftAvatar={userAvatar}
                                        primaryText={"a1"}
                                        secondaryText={"a2"}
                                        className="list"
                                    />
                                    <ListItem
                                        leftAvatar={userAvatar}
                                        primaryText={"b1"}
                                        secondaryText={"b2"}
                                        className="list"
                                    />
                            </List>
                */}
                <Card className="margin-bottom">
                    <CardText>
                        <div className="flex-col">
                                <form className="margin-bottom">
                                    <div className="flex-row">
                                        fdfdsafa
                                        fdsafdasfdas
                                        fdafdasfdas
                                    </div>
                                </form>
                        </div>
                    </CardText>
                </Card>

                <h1 className={"title"}>HEADER</h1>

                    <div className="flex-row flex-space-between margin-header">
                        <h3 className="title">for example roughly this, there are more variants of headers like this .... </h3>
                    </div>

                <h1 className={"title"}>LINK</h1>

                    <span className={"link"}>link text</span>

                <h1 className={"title"}>USER ICON</h1>

                    {userAvatar}

                <h1 className={"title"}>USER INFO BOX</h1>


                    {
                        /*
                        item.senderName
                        ? <span>{item.senderName} (<span className={"link"}>{item.sender}</span>)</span>
                        : <span className={"link"}>{item.sender}</span>
                        */
                    }

                    <ListItem
                        leftAvatar={userAvatar}
                        primaryText={'primary text'}
                        secondaryText={'secondary text'}
                        className="list"
                    />


                <h1 className={"title"}>detail - previous installation icon</h1>
                <FontIcon
                    className="icon"
                >
                    done
                </FontIcon>




                <h1 className="title">tools</h1>


                <Button
                    flat
                    label={"debug_DebugElement_toggle ->" + (+!+storage.get("debug_DebugElement_show"))}
                    className="btn btn-primary"
                    onClick={() => {
                        storage.set("debug_DebugElement_show", +!+storage.get("debug_DebugElement_show"));
                    }}
                />

                <h1 className="title">list of elements</h1>


                Buttons
                \src\containers\Main.js
                <Buttons
                    history={history}
                    className="margin-header"
                    primary={[{label: Translate('request-new', "Nový požadavek"), link: "/request-new"}]}
                    buttons={[
                        {label: Translate("request-received", "Zadat přijatý požadavek"), link: "/request-received"},
                        {label: Translate("project-new", "Vytvořit nový projekt"), link: "/project-new"}
                    ]}
                />


                <Checkbox
                    id="checkbox"
                    name="simple-checkboxes[]"
                    label="checkbox"
                />


                \src\components\requests\Header.js

                <div className="search">
                    <TextField
                        id="search"
                        placeholder="Hledat"
                        className="search-input"
                    />
                    <FontIcon className="search-icon">search</FontIcon>
                </div>

            </div>
        );
    }
    else
    {
        return (
            <div></div>
        );
    }
};

export default compose(
    connect(stateAsDict =>{ return {}; },{getUser}),
    withHandlers({}),
    lifecycle({
        async componentWillMount(){
            let { getUser } = this.props;
            let user = await getUser();
            debug_processUser( user );
    }})
)(DeveloperHelper);


// WEBPACK FOOTER //
// ./src/pages/DeveloperHelper.js